package com.cybersoftsolution.cybersoftsolutionweb.components.htmlEditor

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.cybersoftsolution.cybersoftsolutionweb.styles.CreateStyle
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.editorIdPreview
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.Resize
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.css.Visibility
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.onKeyUp
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.resize
import com.varabyte.kobweb.compose.ui.modifiers.scrollBehavior
import com.varabyte.kobweb.compose.ui.modifiers.visibility
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.document
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.TextArea
import org.w3c.dom.HTMLTextAreaElement


@Composable
    fun Editor(
    text: String = "",
    id: String,
    modifier: Modifier = Modifier,
    editorVisibility: Boolean = true,
    onChange : (String) -> Unit = {},
    ){


    LaunchedEffect(text) {
        (document.getElementById(id) as HTMLTextAreaElement).value = text
    }
        val dimensionsModifier = Modifier
            .fillMaxWidth()
            .height(400.px)
            .maxHeight(400.px)
            .margin(bottom = 24.px)
            .padding { 24.px }
            .borderRadius(4.px)
            .backgroundColor(Theme.LightGray.rgb)

        Box(
            modifier = modifier,
        ) {

            TextArea(
//                value = null,
                attrs = CreateStyle.toModifier()
                    .id(id)
                    .then(dimensionsModifier)
                    .resize(Resize.None)
                    .visibility(
                        if (editorVisibility) Visibility.Visible else Visibility.Hidden
                    )
                    .onKeyUp {
                        val myTextAreaValue = (document.getElementById(id) as HTMLTextAreaElement).value
                        onChange(myTextAreaValue)
                        console.info("myEditorId.${id} ------------ value = " +  myTextAreaValue)
                    }
                    .toAttrs {
                        attr("placeholder", " Introduce tu contenido...")
                    },

            )

            Div(
                attrs = CreateStyle.toModifier()
                    .id(id+ editorIdPreview)
                    .then(dimensionsModifier)
                    .visibility(
                        if (!editorVisibility) Visibility.Visible else Visibility.Hidden
                    )
                    .overflow(Overflow.Auto)
                    .scrollBehavior(ScrollBehavior.Smooth)
                    .toAttrs()
            ) {


            }
        }





    }